<template>
	<div v-if="arrayNoteSpese.length > 0" class="card shadow mb-xs-3 mb-lg-0 mt-3">
		<div class="card-header bg-secondary text-white">
			<div class="d-flex justify-content-between align-items-center">
				<h6 class="mb-0 cursor-pointer" @click="toggleCollapse()">
					<i :class="collapsed ? 'ph-caret-right' : 'ph-caret-down'" class="me-2"></i>
					NOTE SPESE
				</h6>
				<span class="badge bg-danger">&euro; {{ totalImporto }}</span>
			</div>
		</div>

		<div v-if="!collapsed" class="card-body pb-0">
			<div class="alert alert-2 alert-secondary border-0" @click.stop>
				<form autocomplete="off" @submit.prevent>
					<div class="row">
						<div class="col-6 col-md-2 mbx-1">
							<select class="form-control form-control-sm" v-model="filtroTipo">
								<option value="">Tutti i tipi</option>
								<option value="0">Scontrino</option>
								<option value="1">Fattura</option>
							</select>
						</div>
						<div class="col-6 col-md-2 mbx-1">
							<select class="form-control form-control-sm" v-model="filtroUtente">
								<option value="">Tutti gli utenti</option>
								<option v-for="u in utentiDisponibili" :key="'filtro-utente-' + u.FK_ID_UTENTE" :value="u.FK_ID_UTENTE">{{ u.nome }}</option>
							</select>
						</div>
						<div class="col-6 col-md-2 mbx-1">
							<input type="date" class="form-control form-control-sm" v-model="filtroDataDa" title="Data da" />
						</div>
						<div class="col-6 col-md-2 mbx-1">
							<input type="date" class="form-control form-control-sm" v-model="filtroDataA" title="Data a" />
						</div>
						<div class="col-12 col-md-4 mbx-1">
							<input type="text" class="form-control form-control-sm" v-model="filtroTesto" placeholder="Cerca descrizione..." />
						</div>
					</div>
				</form>
			</div>
		</div>

		<div v-if="!collapsed" class="card-body p-0">
			<div class="list-group list-group-flush">
				<div v-for="(utente, idx) in perUtentePaginato" :key="'utente-' + idx" class="list-group-item">
					<div class="cursor-pointer d-flex justify-content-between align-items-center" @click="toggleUtente(utente.FK_ID_UTENTE)">
						<div class="d-flex align-items-center">
							<i :class="utenteCollapsed[utente.FK_ID_UTENTE] !== false ? 'ph-caret-right' : 'ph-caret-down'" class="me-2"></i>
							<strong>{{ utente.nome }}</strong>
						</div>
						<span class="badge bg-danger">&euro; {{ filters.formattaImporto(utente.totale) }}</span>
					</div>

					<div v-if="utenteCollapsed[utente.FK_ID_UTENTE] === false" class="ms-4 mt-2">
						<div v-for="nota in utente.note" :key="'nota-' + nota.ID_NOTA_SPESA" class="row mb-2 align-items-center">
							<div class="col-md-2">
								<small class="text-muted">{{ filters.formatDate(nota.DATA) }}</small>
							</div>
							<div class="col-md-6">
								<i class="ph-file-text me-1 text-muted"></i><small>{{ nota.DESCRIZIONE }}</small>
							</div>
							<div class="col-md-2 text-end">
								<span class="text-danger fs-sm fw-semibold">&euro; {{ filters.formattaImporto(Math.abs(parseFloat(nota.IMPORTO) || 0)) }}</span>
							</div>
							<div class="col-md-2 text-end" @click.stop>
								<div class="dropdown d-inline-block">
									<a href="#" class="text-body p-0" data-bs-toggle="dropdown" aria-expanded="false">
										<i class="ph-list"></i>
									</a>
									<div class="dropdown-menu dropdown-menu-end">
										<a href="#" class="dropdown-item" @click.prevent="$emit('apri-azioni', { azione: 'modifica', notaSpesa: nota })">
											<i class="far fa-edit fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica
										</a>
										<div class="dropdown-divider"></div>
										<a href="#" class="dropdown-item text-danger" @click.prevent="$emit('apri-azioni', { azione: 'elimina', notaSpesa: nota })">
											<i class="far fa-trash-alt fa-fw me-2"></i><span class="text-muted me-1">|</span>Elimina
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row mt-2 px-2 pb-2" v-if="perUtente.length > 0">
				<div class="col-9 col-md-4 ms-auto">
					<div class="float-end pag-mobile">
						<Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="perUtente.length"
							:numpagine="totalPagineNote" :modalita="$root.isMobile ? 2 : 1"></Pagine>
					</div>
				</div>
				<div class="col-3 col-md-1">
					<select class="form-select form-select-sm wmin-100 mt-2 float-end" v-model="search.PAGINATION.PAGE_SIZE">
						<option value="5">5</option>
						<option value="10">10</option>
						<option value="25">25</option>
						<option value="50">50</option>
					</select>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Pagine from '@/components/utils/Pagine.vue';

export default {
	name: 'NoteSpeseProg',
	components: { Pagine },
	props: {
		arrayNoteSpese: {
			type: Array,
			default: () => []
		}
	},
	emits: ['apri-azioni'],
	data() {
		return {
			collapsed: false,
			utenteCollapsed: {},
			filters: global.filters,
			filtroTipo: '',
			filtroUtente: '',
			filtroDataDa: '',
			filtroDataA: '',
			filtroTesto: '',
			search: {
				PAGINATION: { PAGE_NUMBER: 1, PAGE_SIZE: 10 }
			}
		};
	},
	watch: {
		filtroTipo() { this.search.PAGINATION.PAGE_NUMBER = 1; },
		filtroUtente() { this.search.PAGINATION.PAGE_NUMBER = 1; },
		filtroDataDa() { this.search.PAGINATION.PAGE_NUMBER = 1; },
		filtroDataA() { this.search.PAGINATION.PAGE_NUMBER = 1; },
		filtroTesto() { this.search.PAGINATION.PAGE_NUMBER = 1; },
		totalPagineNote(newVal) {
			if (this.search.PAGINATION.PAGE_NUMBER > newVal) {
				this.search.PAGINATION.PAGE_NUMBER = 1;
			}
		}
	},
	computed: {
		utentiDisponibili() {
			const map = {};
			this.arrayNoteSpese.forEach(n => {
				if (!map[n.FK_ID_UTENTE]) {
					map[n.FK_ID_UTENTE] = { FK_ID_UTENTE: n.FK_ID_UTENTE, nome: n.NOME_UTENTE };
				}
			});
			return Object.values(map).sort((a, b) => a.nome.localeCompare(b.nome));
		},
		arrayNoteSpeseFiltrate() {
			return this.arrayNoteSpese.filter(n => {
				if (this.filtroTipo != '' && n.FLG_FATTURA != this.filtroTipo) return false;
				if (this.filtroUtente != '' && n.FK_ID_UTENTE != this.filtroUtente) return false;
				if (this.filtroDataDa != '' && n.DATA < this.filtroDataDa) return false;
				if (this.filtroDataA != '' && n.DATA > this.filtroDataA) return false;
				if (this.filtroTesto != '' && !(n.DESCRIZIONE || '').toLowerCase().includes(this.filtroTesto.toLowerCase())) return false;
				return true;
			});
		},
		perUtente() {
			const grouped = {};

			this.arrayNoteSpeseFiltrate.forEach(nota => {
				const key = nota.FK_ID_UTENTE;
				if (!grouped[key]) {
					grouped[key] = {
						FK_ID_UTENTE: nota.FK_ID_UTENTE,
						nome: nota.NOME_UTENTE,
						note: [],
						totale: 0
					};
				}
				grouped[key].note.push(nota);
				grouped[key].totale += parseFloat(nota.IMPORTO);
			});

			return Object.values(grouped)
				.sort((a, b) => a.FK_ID_UTENTE - b.FK_ID_UTENTE)
				.map(u => ({
					...u,
					totale: u.totale
				}));
		},
		totalPagineNote() {
			return Math.ceil(this.perUtente.length / this.search.PAGINATION.PAGE_SIZE) || 1;
		},
		perUtentePaginato() {
			return global.utils.pagination.paginate(this.perUtente, this.search);
		},
		totalImporto() {
			const sum = this.arrayNoteSpeseFiltrate.reduce((sum, nota) => {
				return sum + (parseFloat(nota.IMPORTO) || 0);
			}, 0);
			return this.filters.formattaImporto(sum);
		}
	},
	methods: {
		toggleCollapse() {
			this.collapsed = !this.collapsed;
		},
		toggleUtente(userId) {
			this.utenteCollapsed[userId] = this.utenteCollapsed[userId] !== false ? false : true;
		}
	}
};
</script>

<style scoped>
.cursor-pointer {
	cursor: pointer;
}

.cursor-pointer:hover {
	background-color: #f8f9fa;
}

.list-group-item {
	border-left: 3px solid transparent;
	transition: border-color 0.2s;
}

.list-group-item:hover {
	border-left-color: #007bff;
}
</style>
